<template>
  <div>
    <AppLoader />
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth.js'
import { useLoaderStore } from '@/stores/loader.js'
import AppLoader from '@/components/common/AppLoader.vue'

const authStore = useAuthStore()
const loaderStore = useLoaderStore()

onMounted(() => {
  authStore.initializeStore()
  // Masquer le loader initial si visible (premier chargement)
  loaderStore.hide()
})
</script>
